import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatRadioModule } from '@angular/material/radio';
import { SidebarStationComponent } from './../sidebar-station/sidebar-station.component';
import { SiaWavesurferComponent } from './sia-wavesurfer/sia-wavesurfer.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IhmLoadingIndicatorModule } from '@ihm-software/ihm-ui-common-angular-10';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgStreamingModule } from '@videogular/ngx-videogular/streaming';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { NgWaveformModule } from 'ng-waveform';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import { AudioPlayerComponent } from './audio-player';
import { BadgeStationComponent } from './badge-station/badge-station.component';
import { CapitalizePipe } from './capitalize.pipe';
import { ConfirmationDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { DataColumnComponent, DataTableComponent } from './data-table';
import { DatePickerComponent } from './date-picker';
import { ResizerDirective } from './directives/resize.directive';
import { FormatFrequencyPipe } from './formatFrequency.pipe';
import { HumanDurationPipe } from './human-duration.pipe';
import { MarketFormatPipe } from './market-format.pipe';
import { MultiDropboxComponent } from './multi-dropbox';
import { PlayerHeaderComponent } from './player-header';
import { PlayerSidenavComponent } from './player-sidenav';
import { PlayerSidenavReferencesService } from './player-sidenav-references';
import { SearchFilterComponent } from './search-filter';
import { SiaLoadingComponent } from './sia-loading/sia-loading.component';
import { SingleDatePickerComponent } from './single-date-picker';
import { SingleDropboxComponent } from './single-dropbox';
import { SingleTimePickerComponent } from './single-time-picker';
import { StationCardComponent, StationCardHoverComponent } from './station-card';
import { StationCardDialogComponent } from './station-card/station-card-dialog/station-card-dialog.component';
import { StylizedTextPipe } from './stylized-text.pipe';
import { TruncateTextPipe } from './truncate-text.pipe';
import { TimeBarComponent } from './waveform/time-bar/time-bar.component';
import { WaveformComponent } from './waveform/waveform.component';
import { FormatFancyTimePipe } from './pipes/format-fancy-time.pipe';
import { SiaWaveTrackComponent } from './sia-wavesurfer/sia-wave-track/sia-wave-track.component';
import { MatBadgeModule } from '@angular/material/badge';

@NgModule({
  imports: [
    IhmLoadingIndicatorModule.forRoot(true),
    CommonModule,
    MatBadgeModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSidenavModule,
    MatCardModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    VgStreamingModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    NgWaveformModule,
    MatRadioModule,
    MatTreeModule,
    MatTabsModule
  ],
  entryComponents: [ConfirmationDialogComponent],
  declarations: [
    AudioPlayerComponent,
    MultiDropboxComponent,
    SingleDropboxComponent,
    PlayerSidenavComponent,
    PlayerHeaderComponent,
    SearchFilterComponent,
    StationCardComponent,
    StationCardHoverComponent,
    ConfirmationDialogComponent,
    HumanDurationPipe,
    StylizedTextPipe,
    CapitalizePipe,
    DatePickerComponent,
    SingleDatePickerComponent,
    SingleTimePickerComponent,
    MarketFormatPipe,
    TruncateTextPipe,
    FormatFrequencyPipe,
    DataColumnComponent,
    DataTableComponent,
    ResizerDirective,
    SiaLoadingComponent,
    BadgeStationComponent,
    StationCardDialogComponent,
    TimeBarComponent,
    WaveformComponent,
    FormatFancyTimePipe,
    SiaWavesurferComponent,
    SiaWaveTrackComponent,
    SidebarStationComponent
  ],
  providers: [PlayerSidenavReferencesService, MarketFormatPipe],
  exports: [
    MatBadgeModule,
    MatSidenavModule,
    MultiDropboxComponent,
    SingleDropboxComponent,
    AudioPlayerComponent,
    PlayerSidenavComponent,
    PlayerHeaderComponent,
    SearchFilterComponent,
    StationCardComponent,
    StationCardHoverComponent,
    HumanDurationPipe,
    StylizedTextPipe,
    CapitalizePipe,
    DatePickerComponent,
    SingleDatePickerComponent,
    SingleTimePickerComponent,
    MarketFormatPipe,
    TruncateTextPipe,
    FormatFrequencyPipe,
    DataColumnComponent,
    DataTableComponent,
    ResizerDirective,
    MatDialogModule,
    SiaLoadingComponent,
    BadgeStationComponent,
    TimeBarComponent,
    WaveformComponent,
    FormatFancyTimePipe,
    SiaWavesurferComponent,
    MatCardModule,
    SidebarStationComponent,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSidenavModule,
    MatCardModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    VgStreamingModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    NgxMatSelectSearchModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    NgWaveformModule,
    MatRadioModule,
    MatTreeModule,
    MatTabsModule
  ]
})
export class SharedModule {

  constructor () {
  }
}
